export default __webpack_public_path__ + "static/media/steeltype-blue.9d0486e1.svg";